import { defineStore } from "pinia";
import usuarioModel from "@/models/usuarioModel";
import { home } from "../utils/usuarioRedirections";
import garantiaModel from "@/models/garantiaModel";

export const useUsuarioStore = defineStore("usuario", {
  state: () => ({
    user: { ...usuarioModel.data },
    loginError: null,
    resumenGarantias: { saldo: 0, credito: 0 },
  }),
  actions: {
    async iniciarSesion(
      email = this.user.email,
      password = this.user.password
    ) {
      try {
        this.loginError = null;
        const response = await usuarioModel.iniciarSesion(email, password);
        if (response && response.token) {
          localStorage.setItem("token", response.token);
          localStorage.setItem("user", JSON.stringify(response.user));
          home();
          return true;
        }
        this.loginError = "Respuesta inválida del servidor. Intentá nuevamente.";
        return false;
      } catch (error) {
        if (error.response?.status === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");

          this.loginError =
            error.response.data.error || "Error en la autenticación";
        } else if (error.response) {
          this.loginError = `Error ${error.response.status}: ${
            error.response.data?.error || error.response.data?.message || "sin detalle"
          }`;
        } else {
          this.loginError = "No se pudo conectar con el servidor.";
        }
        return false;
      }
    },

    async getSession() {
      const token = localStorage.getItem("token");

      if (!token) {
        localStorage.removeItem("user");
        localStorage.removeItem("credito");
        localStorage.removeItem("saldo");
        return;
      }

      try {
        const response = await usuarioModel.getSession();
        localStorage.setItem("user", JSON.stringify(response.user.original));
        this.user = response.user.original;
      } catch (error) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("credito");
        localStorage.removeItem("saldo");
        this.user = { ...usuarioModel.data };
      }
    },

    async refrescarResumenGarantiasUsuario() {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const data = await garantiaModel.obtenerResumenGarantia();
        const resumen = data.find((item) => item.moneda === "ARS");
        localStorage.setItem("credito", resumen?.credito);
        localStorage.setItem("saldo", resumen?.saldo);
        this.resumenGarantias = {
          saldo: resumen?.saldo,
          credito: resumen?.credito,
        };
      } catch (error) {
        this.resumenGarantias = { saldo: 0, credito: 0 };
        console.log("Error al obtener resumen");
      }
    },

    async registrarUsuario(
      name = this.user.name,
      email = this.user.email,
      password = this.user.password
    ) {
      try {
        this.user.name = this.user.email.split("@")[0];
        if (this.user.password === this.user.passwordrepit)
          await usuarioModel.registrarUsuario(name, email, password);
        else return false;
        await this.iniciarSesion(email, password);
      } catch (error) {
        alert(error.response?.data?.error);
      }
    },

    async cerrarSesion() {
      try {
        localStorage.setItem("user", null);
        await usuarioModel.cerrarSesion();
      } catch (e) {
        console.error(e);
      } finally {
        this.$reset();
        localStorage.removeItem("user");
        localStorage.removeItem("credito");
        localStorage.removeItem("saldo");
        localStorage.removeItem("token");
        home();
      }
    },

    async confirmarLoginExterno({ token, session_id, id }) {
      try {
        const response = await usuarioModel.confirmarLoginExterno({
          token,
          session_id,
          id,
        });

        localStorage.setItem("token", response.token);
        localStorage.setItem("user", JSON.stringify(response.user));

        this.token = response.token;
        this.user = response.user;
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {
    isLoggedIn() {
      return localStorage.getItem("token") === null ? false : true;
    },
    getUsuario() {
      return JSON.parse(localStorage.getItem("user")) ?? null;
    },
    getCreditoUsuario() {
      const value = localStorage.getItem("credito");
      return value !== null && value !== "null" ? Number(value) : null;
    },
    getSaldoUsuario() {
      return Number(localStorage.getItem("saldo")) || 0;
    },
  },
});
